











































import { Component, Prop, Vue } from 'vue-property-decorator'
import Table from '@/components/Table.vue'

@Component
export default class CardTable extends Table {
	// @Prop() public headers!: object[]
	// @Prop() public rows!: object[]
	private selectedId: number = -1
	private selectedName: string = ''

	private onSwipeLeft(id, name) {
		this.selectedId = id
		this.selectedName = name
	}

	private onTap(id, name) {
		if (this.selectedId === id && this.selectedName === name) {
			this.resetSelected()
			return
		}
		this.selectedId = id
		this.selectedName = name
	}

	private resetSelected() {
		this.selectedId = -1
		this.selectedName = ''
	}
}
